import type { EventTransport } from '../EventTransport';
import type { SystemEventResponse } from '../../../types/event.types';
import { getEvents } from '../../../api/eventsApi';

const POLL_INTERVAL_MS = 10000;

const sleep = (ms: number): Promise<void> =>
    new Promise(resolve => setTimeout(resolve, ms));

export class PollingTransport implements EventTransport {
    private readonly pollIntervalMs: number;
    private cursor?: string;
    private stopped = false;

    constructor(pollIntervalMs: number = POLL_INTERVAL_MS) {
        this.pollIntervalMs = pollIntervalMs;
    }

    connect(onMessage: (messgae: SystemEventResponse) => void): void {
        this.stopped = false;

        const poll = async(): Promise<void> => {
            try {
                const response = await getEvents(this.cursor);
                if (this.stopped) {
                    return;
                }
                this.cursor = response.cursor ?? this.cursor;
                response.events.forEach(event => onMessage(event));
            } catch (error) {
                if (import.meta.env.DEV) {
                    console.log('[events] poll failed', error);
                }
            }
        };

        const run = async (): Promise<void> => {
            while (!this.stopped) {
                await poll();

                if (this.stopped) {
                    break;
                }

                await sleep(this.pollIntervalMs);
            }
        };

        void run();
    }

    disconnect(): void {
        this.stopped = true;
    }
}
